import {rxrLightTint} from '../../assets/styles/color'
import {spaceExtraExtraSmall, spaceExtraSmall} from '../../assets/styles/spacing'
import {ColumnConfig} from '../SortableTable'
import HighlightText from '../HighlightText'
import React from 'react'

const buildingLabelStyles = {
  whiteSpace: 'nowrap',
  display: 'inline-block',
  backgroundColor: rxrLightTint,
  padding: `${spaceExtraExtraSmall}px ${spaceExtraSmall}px`,
  borderRadius: '2px',
  margin: `${spaceExtraExtraSmall}px ${spaceExtraSmall}px ${spaceExtraExtraSmall}px 0`,
}
/**
 * @param {string} filterTerm
 * @return {ColumnConfig}
 */
export const getBuildingLabelsColumnConfig = filterTerm =>
  new ColumnConfig({
    title: 'Assets',
    renderPrimitive: item => item.buildingsLabel,
    render: (r, col) => {
      const buildingsCount = r.buildings.length
      const MAX_BUILDINGS_TO_SHOW = 2
      return (
        <div style={{whiteSpace: 'nowrap'}}>
          {r.buildings.slice(0, MAX_BUILDINGS_TO_SHOW).map(b => {
            return (
              <span key={b.id} style={buildingLabelStyles}>
                <HighlightText search={filterTerm}>{b.displayName}</HighlightText>
              </span>
            )
          })}
          {buildingsCount > MAX_BUILDINGS_TO_SHOW && <span>+&nbsp;{buildingsCount - MAX_BUILDINGS_TO_SHOW}</span>}
        </div>
      )
    },
    comparator: ColumnConfig.simpleComparatorGenerator('buildingsLabel'),
  })
